import * as api from '../api/payouts.js';
import q from '../query.js';
import keys from '@debbie/common/dist/cache/keys.js';
export const payoutsEntity = `payouts`;
const payoutsKey = (filter, page, pageSize) => `payouts-${JSON.stringify(filter)}-${page}-${pageSize}`;
export const usePayouts = (filters, page, pageSize) => q.query(payoutsKey(filters, page, pageSize), () => api.get(filters, page, pageSize), keys.read.collection(payoutsEntity));
const payoutKey = (id) => `payouts-${id}`;
export const usePayout = (id) => q.query(payoutKey(id), () => api.getById(id), keys.read.item(payoutsEntity, id));
//# sourceMappingURL=index.js.map